<img class="right-oval" src="assets/img/ovals/grey-oval-right.png" />

<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        [text]="deviceService.isMobile ? '' : 'Back to search'"
        defaultHref="events"
        (click)="goBack()"
      ></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="page-container">
    <div class="loading-container" *ngIf="!eventInfo">
      <ion-spinner></ion-spinner>
    </div>

    <div *ngIf="eventInfo">
      <div class="info-section">
        <div class="info-title">{{ eventInfo.name }}</div>
        <div class="info-description">{{ eventInfo.description }}</div>
        <div class="info-services">
          <ion-icon class="services-icon" name="cut"></ion-icon>
          <span class="services-text"
            >Shortcut {{ eventInfo.longServiceNames }}</span
          >
        </div>
        <div class="info-details">
          <div class="details-title">Details</div>
          <div class="detail">
            {{ adjustedDate(eventInfo.startTime, eventInfo.timezoneOffset) |
            timeRangeLong : adjustedDate(eventInfo.endTime,
            eventInfo.timezoneOffset) }} {{ eventInfo.timezoneAbbreviation }}
          </div>
          <div class="details">
            {{ prettyAdjustedDate(eventInfo.startTime, eventInfo.timezoneOffset)
            }}
          </div>
          <div class="details">{{ eventInfo.locationDescription }}</div>
        </div>
        <div class="attending-details">
          <div class="attending-inner-container">
            <div class="attending-images">
              <img src="assets/img/user-profile-1.jpg" />
              <img src="assets/img/user-profile-3.jpg" />
              <img src="assets/img/user-profile-2.jpg" />
            </div>
            <div class="text">
              <div class="attending-text">
                {{ eventInfo.prosAndServices.length }} Pro{{
                eventInfo.prosAndServices.length === 1 ? '' : 's' }} available
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-wrapper">
        <div *ngIf="eventInfo.logo">
          <img class="right-img" [src]="eventInfo.logo" />
        </div>
        <div *ngIf="!eventInfo.logo">
          <img
            class="right-img"
            src="assets/img/thrillist.jpg"
            *ngIf=" eventType() == 'Hair' "
          />
          <img
            class="right-img"
            src="assets/img/massage.jpg"
            *ngIf=" eventType() == 'Massage' "
          />
          <img
            class="right-img"
            src="assets/img/nails.jpg"
            *ngIf=" eventType() == 'Nails' "
          />
        </div>

        <div class="slack-wrapper">
          <a class="slack-button" [href]="slackUrl"
            ><img
              alt="Add to Slack"
              height="40"
              width="139"
              src="https://platform.slack-edge.com/img/add_to_slack.png"
              srcset="
                https://platform.slack-edge.com/img/add_to_slack.png    1x,
                https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
              "
          /></a>

          <div class="slack-text">
            Add our Slack integration to get reminders for Shortcut events at {{
            eventInfo.name }}.
          </div>
        </div>
      </div>

      <hr />

      <div class="select-services-container">
        <div class="title-container" (click)="selectServicePressed()">
          <p class="services-title">
            <span *ngIf="selectedService"
              >{{ selectedService.serviceTitle }}</span
            >
            <span *ngIf="!selectedService" class="bold">Select a service</span>
          </p>
          <ion-icon
            name="chevron-down-outline"
            color="marine"
            class="SC-edit-icon"
          ></ion-icon>
        </div>
      </div>

      <hr />

      <!-- <div class="pro-section" *ngIf="eventInfo && !prosAndTimeslots">
        <div class="card-group-w-header">

          <h3 class="title">Pros at this event</h3>

          <div class="barber-cards">
            <ion-card class="barber-card" *ngFor="let pS of eventInfo.prosAndServices"
              (click)="goToBarber(pS.pro.link)">

              <ion-card-content class="barber-card-content">

                <div class="col-barber-img">
                  <img [src]="pS.pro.pic" class="barber-img" />
                </div>

                <div class="col-barber-info">
                  <h4> {{pS.pro.fullName}} </h4>

                  <div class="barber-stars">
                    <ion-icon name="star" class="SC-star-icon"
                      [ngClass]="pS.pro.numRatings <= 3 ? 'stars-less-opaque' : ''"
                      *ngFor="let _ of toRange(roundedRating(pS.pro.rating))"></ion-icon>

                    <span class="rating-label"
                      *ngIf="pS.pro.numRatings > 3">({{pS.pro.numRatings}})</span>
                  </div>
                </div>

                <div class="card-bottom">
                  <div class="recent-curated-review" *ngIf="pS.pro.featuredReview">
                    <img src="assets/img/quote.png" class="quote-img" />
                    <p class="recent-quote">{{pS.pro.featuredReview}} <span class="quoter">–
                        {{pS.pro.featuredReviewFirstName}}</span></p>
                  </div>
                  <div *ngIf="!pS.pro.featuredReview">
                    <ion-button fill="outline" class="action-button">Book {{pS.pro.fullName}}</ion-button>
                  </div>
                </div>

              </ion-card-content>
            </ion-card>

          </div>

        </div>
      </div> -->

      <div class="pro-section" *ngIf="eventInfo && hasOpenTimeslots()">
        <div class="card-group-w-header">
          <h3 class="title">Click on an Available Pro</h3>

          <div class="barber-cards">
            <ion-card
              class="barber-card"
              *ngFor="let barberTimeslot of prosAndTimeslots"
              (click)="goToBarberWithTimeslots(barberTimeslot)"
            >
              <ion-card-content class="barber-card-content">
                <div class="col-barber-img">
                  <img [src]="barberTimeslot.pro.pic" class="barber-img" />
                </div>

                <div class="col-barber-info">
                  <h4>{{barberTimeslot.pro.fullName}}</h4>

                  <div class="barber-stars">
                    <ion-icon
                      name="star"
                      class="SC-star-icon"
                      [ngClass]="barberTimeslot.pro.numRatings <= 3 ? 'stars-less-opaque' : ''"
                      *ngFor="let _ of toRange(roundedRating(barberTimeslot.pro.rating))"
                    ></ion-icon>

                    <span
                      class="rating-label"
                      *ngIf="barberTimeslot.pro.numRatings > 3"
                      >({{barberTimeslot.pro.numRatings}})</span
                    >
                    <!-- <span class="rating-label gold" *ngIf="barberTimeslot.pro.numRatings <= 3">(Newly added)</span> -->
                  </div>
                </div>

                <div class="openings-text">
                  <ion-icon name="time"></ion-icon>
                  <span>{{barberTimeslot.timeslots.length}} openings</span>
                </div>

                <div class="card-bottom">
                  <div
                    class="recent-curated-review"
                    *ngIf="barberTimeslot.pro.featuredReview"
                  >
                    <img src="assets/img/quote.png" class="quote-img" />
                    <p class="recent-quote">
                      {{barberTimeslot.pro.featuredReview}}
                      <span class="quoter"
                        >– {{barberTimeslot.pro.featuredReviewFirstName}}</span
                      >
                    </p>
                  </div>
                  <div>
                    <ion-button fill="outline" class="action-button"
                      >Book {{barberTimeslot.pro.fullName}}</ion-button
                    >
                  </div>
                </div>
              </ion-card-content>
            </ion-card>
          </div>
        </div>
      </div>

      <div
        class="SC-empty-state-div"
        *ngIf="eventInfo && eventInfo.numTotalTimeslots == 0"
      >
        <ion-icon name="calendar" class="SC-empty-state-icon"></ion-icon>
        <p class="SC-empty-state-text">Timeslots not yet available</p>
        <p class="SC-empty-state-action SC-clickable" (click)="joinWaitlist()">
          Join Waitlist
        </p>
      </div>

      <div
        class="SC-empty-state-div"
        *ngIf="eventInfo && prosAndTimeslots && !hasOpenTimeslots() && eventInfo.numTotalTimeslots != 0"
      >
        <ion-icon name="calendar" class="SC-empty-state-icon"></ion-icon>
        <p class="SC-empty-state-text">
          No remaining timeslots for this service
        </p>
        <p class="SC-empty-state-action SC-clickable" (click)="joinWaitlist()">
          Join Waitlist
        </p>
      </div>
    </div>
  </div>
</ion-content>
